import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, Radio, Tag } from 'antd';
import Menu from '../../components/Menu/Menu';
import './Providers.scss';
import Header from '../../components/Header/Header';
import MobileMenu from "../../components/Menu/MobileMenu";
import { Link } from 'react-router-dom';
import { SaveOutlined } from '@ant-design/icons';
import { providersService } from "../../services/ProvidersService";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { productsService } from "../../services/ProductsService";
import { useParams, useNavigate} from 'react-router-dom';

const { Option } = Select;
const AddProvider = () => {
    const [form] = Form.useForm();
    const { Search } = Input;
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const { id } = useParams();
    const navigate=useNavigate();
    useEffect(() => {
        if (id) {
            providersService.getSpecificSupplier(id)
                .then(res => {
                    const supplier = res.data;

                    form.setFieldsValue({
                        name: supplier.name,
                        email: supplier.email,
                        telefon: supplier.phone,
                        entity_type: supplier.entity_type === 'company' ? 'firma' : 'persoana fizica',
                        registration_number: supplier.registration_number,
                        cui: supplier.cui,
                        vat_payer: supplier.vat_payer ? 'da' : 'nu',
                        banca: supplier.bank_name,
                        iban: supplier.iban,
                        representative_name: supplier.representative_name,
                        country: supplier.country,
                        county: supplier.county,
                        city: supplier.city,
                        street: supplier.street,
                        street_number: supplier.street_number,
                        codPostal: supplier.postal_code,
                        service_type: supplier.service_type,
                        participates_in_offering: supplier.participates_in_offering ? 'da' : 'nu',
                        order_day: supplier.order_day || 'any',
                    });
                })
                .catch(err => {
                    toast.error('Nu s-au putut încărca datele furnizorului.');
                    console.error("Eroare la preluare furnizor:", err);
                });

            providersService.getProductAttributions(id)
                .then(res => {
                    const attributions = res.data.attributions;
                    const products = attributions.map(attr => attr.product);
                    setSelectedProducts(products);

                })
                .catch(err => {
                    toast.error('Nu s-au putut încărca atribuțiile de produse.');
                    console.error("Eroare la atribuții:", err);
                });
        }
    }, [id, form]);
    const handleFinish = (values) => {
        const payload = {
            name: values.name,
            email: values.email,
            phone: values.telefon,
            entity_type: values.entity_type === 'firma' ? 'company' : 'individual',
            registration_number: values.registration_number,
            cui: values.cui ? Number(values.cui) : undefined,
            vat_payer: values.vat_payer === 'da',
            bank_name: values.banca,
            iban: values.iban,
            representative_name: values.representative_name,
            country: values.country,
            county: values.county,
            city: values.city,
            street: values.street,
            street_number: values.street_number,
            postal_code: values.codPostal,
            service_type: values.service_type,
            participates_in_offering: values.participates_in_offering === 'da' ? true : false,
            order_day: values.order_day || 'any'
        };

        const request = id
            ? providersService.editProvider(id, payload)
            : providersService.addProvider(payload);

        request
            .then(() => {
                toast.success(
                    id
                        ? 'Furnizorul a fost actualizat cu succes!'
                        : 'Furnizorul a fost adăugat cu succes!'
                );
                form.resetFields();
                setTimeout(() => {
                    navigate('/furnizori'); 
                }, 2000);
            })
            .catch((error) => {
                toast.error(
                    id
                        ? 'A apărut o eroare la actualizarea furnizorului.'
                        : 'A apărut o eroare la adăugarea furnizorului.'
                );
                console.error(error);
            });
    };
    const handleSearch = (value) => {
        setSearchQuery(value);
        if (value.length > 0) {
            productsService.searchProduct(value, 1)
                .then(res => {
                    if (res.data?.products) {
                        setSearchResults(res.data.products);
                    } else {
                        setSearchResults([]);
                    }
                })
                .catch(err => {
                    console.error("Eroare la căutare:", err);
                    setSearchResults([]);
                });
        } else {
            setSearchResults([]);
        }
    };
    const handleProductSelect = (
        product,
        setSelectedProducts,
        setSearchQuery,
        setSearchResults
    ) => {
        const productId = product.id;

        providersService.addProductAttributions(id, [productId])
            .then(() => {
                setSelectedProducts(prev => {
                    if (!prev.find(p => p.id === productId)) {
                        return [...prev, product];
                    }
                    return prev;
                });

                setSearchQuery('');
                setSearchResults([]);
            })
            .catch(err => {
                console.error("Eroare la adăugarea produsului:", err);
            });
    };
    const handleRemoveProduct = (productId) => {
        if (!id) return;

        providersService.deleteAttribution(id, productId)
            .then(() => {
                setSelectedProducts(prev => prev.filter(p => p.id !== productId));
            })
            .catch(err => {
                console.error("Eroare la ștergerea atribuirii produsului:", err);
            });
    };
    return (
        <div className='standard products  providers'>
            <Header />
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />
            </div>

            <div className='standard__container '>
                <Menu />
                <div className='standard__wrapper'>
                    <div style={{ padding: 24, minHeight: 280 }}>
                        <h2 className='standard__page-title'>    {id ? 'Editează furnizor' : 'Adaugă furnizor nou'}
                        </h2>
                        <h4 className='standard__page-info'>
                            {id ? ' Editeaza informațiile necesare.' : ' Completează informațiile necesare pentru a înregistra un furnizor nou'}

                        </h4>
                        <div className='providers__top'>
                            <Link to='/furnizori' className='standard__link'>
                                <div className='biding__back'>
                                    <img src="/images/back.png" alt="back" />
                                    <h4> Înapoi la furnizori</h4>
                                </div>
                            </Link>

                        </div>
                        <Form
                            form={form}
                            className='providers__wrapper'
                            layout="vertical"
                            onFinish={handleFinish}
                            style={{ marginTop: 32, maxWidth: 800 }}
                        >
                            <Button
                                icon={<SaveOutlined />}
                                className='providers__submit-button'
                                htmlType="submit"
                                style={{ backgroundColor: '#ffff', color: '#000', border: '1px solid #d9d9d9' }}
                            >
                                Salvează furnizorul
                            </Button>
                            <div className='providers__left-side'>
                                <h2 className='providers__section-title'>Identificare rapida</h2>
                                <Form.Item
                                    label="Tip furnizor"
                                    name="entity_type"
                                    rules={[{ required: true, message: 'Selectează tipul de furnizor' }]}
                                >
                                    <Select placeholder="Selectează tipul de furnizor">
                                        <Option value="firma">Firmă</Option>
                                        <Option value="persoana fizica">Persoană fizică</Option>
                                    </Select>
                                </Form.Item>

                                <div className='providers__line' />

                                <h2 className='providers__section-title'>Interacțiune cu platforma</h2>
                                <Form.Item
                                    label="Tip serviciu"
                                    name="service_type"
                                    rules={[{ required: true, message: 'Selectează tipul de serviciu' }]}
                                >
                                    <Select placeholder="Selectează tipul de serviciu">
                                        <Option value="1">1</Option>
                                        <Option value="2">2</Option>
                                        <Option value="3">3</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label="Participă la ofertare"
                                    name="participates_in_offering"
                                    rules={[{ required: true, message: 'Selectează o opțiune' }]}
                                >
                                    <Select placeholder="Selectează opțiunea">
                                        <Option value="da">Da</Option>
                                        <Option value="nu">Nu</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label="Zi comandă"
                                    name="order_day"
                                >
                                    <Select placeholder="Selectează ziua de comandă">
                                        <Option value="luni">Luni</Option>
                                        <Option value="marti">Marți</Option>
                                        <Option value="miercuri">Miercuri</Option>
                                        <Option value="joi">Joi</Option>
                                        <Option value="vineri">Vineri</Option>
                                    </Select>
                                </Form.Item>
                                <div className='list__search-box providers__search-box'>
                                    <Form.Item label="Atribuie produs">

                                        <Search
                                            className="list__search-input"
                                            placeholder="Caută produse"
                                            onChange={(e) => handleSearch(e.target.value)}
                                            value={searchQuery}
                                            enterButton
                                            allowClear
                                        />
                                    </Form.Item>
                                    {searchResults.length > 0 && (
                                        <ul className="list__search-dropdown providers__search-dropdown">
                                            {searchResults.map((product) => {
                                                const regex = new RegExp(`(${searchQuery})`, "gi");
                                                const highlightedName = product.name.replace(regex, (match) => `<span class="search__highlight">${match}</span>`);

                                                return (
                                                    <div className='search__result' key={product.id}>
                                                        <img src='/images/search.png' alt='search' />
                                                        <li>
                                                            <a
                                                                className='standard__link'
                                                                href="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleProductSelect(product, setSelectedProducts, setSearchQuery, setSearchResults);
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: highlightedName }}
                                                            />
                                                        </li>
                                                    </div>
                                                );
                                            })}
                                        </ul>
                                    )}
                                    <div className="providers__selected-products">
                                        {selectedProducts.map((product) => (
                                            <Tag
                                                key={product.id}
                                                closable
                                                onClose={() => handleRemoveProduct(product.id)}
                                                style={{ marginBottom: 8 }}
                                            >
                                                {product.name}
                                            </Tag>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="providers__right-side">
                                <h2 className='providers__section-title'>Date de identificare</h2>
                                <Form.Item
                                    label="Nume"
                                    name="name"
                                    rules={[{ required: true, message: 'Introdu numele furnizorului' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Nr. reg. com."
                                    name="registration_number"
                                    rules={[{ required: true, message: 'Introdu numărul de înregistrare' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="CUI"
                                    name="cui"
                                    rules={[
                                        { required: true, message: 'Introdu CUI-ul' },
                                        {
                                            validator: (_, value) => {
                                                if (value === undefined || value === null || value === '') return Promise.resolve();
                                                const numeric = String(value).trim();
                                                if (!/^\d+$/.test(numeric)) return Promise.reject(new Error('CUI trebuie să conțină doar cifre'));
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                >
                                    <Input inputMode="numeric" />
                                </Form.Item>

                                <Form.Item
                                    label="Plătitor TVA"
                                    name="vat_payer"
                                    rules={[{ required: true, message: 'Selectează opțiunea de TVA' }]}
                                >
                                    <Radio.Group className="providers__bullets">
                                        <Radio value="da">Da</Radio>
                                        <Radio value="nu">Nu</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <h2 className='providers__section-title'>Date financiare</h2>
                                <Form.Item
                                    label="Banca"
                                    name="banca"
                                    rules={[{ required: true, message: 'Introdu numele băncii' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="IBAN"
                                    name="iban"
                                    rules={[{ required: true, message: 'Introdu IBAN-ul' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <h2 className='providers__section-title'>Date de contact</h2>
                                <Form.Item
                                    label="Nume reprezentant"
                                    name="representative_name"
                                    rules={[{ required: true, message: 'Introdu numele reprezentantului' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Telefon"
                                    name="telefon"
                                    rules={[{ required: true, message: 'Introdu numărul de telefon' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[
                                        { required: true, message: 'Introdu adresa de email' },
                                        { type: 'email', message: 'Adresa de email nu este validă' },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Țară"
                                    name="country"
                                    rules={[{ required: true, message: 'Introdu țara' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Județ"
                                    name="county"
                                    rules={[{ required: true, message: 'Introdu județul' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Oraș"
                                    name="city"
                                    rules={[{ required: true, message: 'Introdu orașul' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Stradă"
                                    name="street"
                                    rules={[{ required: true, message: 'Introdu strada' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Număr stradă"
                                    name="street_number"
                                    rules={[{ required: true, message: 'Introdu numărul străzii' }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item
                                    label="Cod poștal"
                                    name="codPostal"
                                    rules={[{ required: true, message: 'Introdu codul poștal' }]}
                                >
                                    <Input />
                                </Form.Item>
                            </div>

                        </Form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddProvider;